<template>
  <nav
    v-if="!mobile"
    :class="['navigation desktop', { invert }]"
    ref="navigation"
  >
    <ul class="hide-print">
      <li
        v-for="link in site.navigation"
        :key="link.title"
      >
        <vue-link
          :to="link.link"
          :key="link.title"
          v-scroll-to="getScrollTo(link)"
          >{{ link.title }}</vue-link
        >
      </li>
      <li>
        <a
          href="#channels"
          class="channels-button"
          >CHANNELS</a
        >
      </li>
    </ul>
    <div class="title">
      <vue-link
        to="/"
        title="Return Home"
        ><img :src="logo"
      /></vue-link>
    </div>
    <div class="nav-meta">
      <vue-link
        to="/cart"
        v-if="this.cartCount > 0"
        :class="['cart']"
        >Cart ({{ this.cartCount }})</vue-link
      >
    </div>
  </nav>
  <nav
    v-else
    :class="['navigation mobile', { invert }]"
  >
    <div class="title">
      <vue-link
        to="/"
        title="Return Home"
        ><img :src="logo"
      /></vue-link>
    </div>
    <vue-link
      to="/cart"
      v-if="this.cartCount > 0"
      :class="['cart']"
      >Cart ({{ this.cartCount }})</vue-link
    >
    <button
      @click="toggleMenu"
      title="Toggle Menu"
    >
      {{ mobileActive ? 'Close' : 'Menu' }}
    </button>
    <div
      v-if="mobileActive"
      class="menu"
    >
      <hr />
      <ul class="big">
        <li
          v-for="link in site.navigation"
          :key="link.title"
        >
          <vue-link
            :to="link.link"
            :key="link.title"
            v-scroll-to="getScrollTo(link)"
            >{{ link.title }}</vue-link
          >
        </li>
        <li>
          <a
            href="#channels"
            class="channels-button"
            >CHANNELS</a
          >
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import PageMixin from '@/mixins/PageMixin'
import logo from '../assets/logo.svg'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram, faTwitter, faFacebook, faFacebookSquare } from '@fortawesome/free-brands-svg-icons'

import { getTotalCartItems } from '@/lib/shopify-utils'

library.add(faInstagram)
library.add(faTwitter)
library.add(faFacebook)
library.add(faFacebookSquare)

export default {
  name: 'GlobalNavigation',
  mixins: [PageMixin],
  props: {
    title: String,
  },
  data() {
    return {
      logo: logo,
    }
  },
  computed: {
    mobile() {
      return this.$store.state.mobile
    },
    isHomepage() {
      return this.$route.path === '/'
    },
    mobileActive() {
      return this.$store.state.navigation.open
    },
    invert() {
      return this.$route.meta.invert
    },
    cartCount() {
      if (this.$store.state.cartData) {
        return getTotalCartItems(this.$store.state.cartData)
      }

      return 0
    },
  },
  methods: {
    toggleMenu() {
      this.$store.commit('updateNavigationMeta', {
        open: !this.mobileActive,
      })
    },
    closeMenu() {
      this.$store.commit('updateNavigationMeta', { open: false })
    },
    getScrollTo({ link }) {
      let hash = link.match(/#.+/)
      if (this.isHomepage && hash) {
        return {
          el: hash[0],
          offset: -50,
          onStart: this.closeMenu,
        }
      }
    },
    getCartCount(lineItems) {
      let count = 0
      lineItems.forEach((item) => (count += item.quantity))
      return count
    },
    getSocialIcon(title) {
      return title === 'facebook' ? 'facebook-square' : title
    },
  },
}
</script>

<style scoped>
nav {
  background: #000;
  text-transform: uppercase;
  padding: var(--p1);
  line-height: 1;
  z-index: 10;
  font: var(--nord);
  position: sticky;
  top: 0;
}

nav.invert {
  background: #fff;
}

nav.desktop {
  display: flex;
  justify-content: space-between;
  text-align: center;
}

ul {
  display: flex;
  list-style: none;
}

ul li:not(:last-child) {
  margin-right: 2rem;
}

li.follow > a:not(:last-child) {
  margin-right: 1rem;
}

.title {
  pointer-events: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.title > * {
  pointer-events: auto;
}

.title img {
  margin: 1rem 0;
  height: 3rem;
  width: 6.6rem;
}

nav.invert .title img {
  filter: invert(1);
}

.title span {
  display: block;
  padding: var(--p1);
}

button {
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  text-transform: inherit;
  cursor: pointer;
  outline: 0;
}

nav.desktop.muted {
  color: #666;
}

.nav-meta {
  display: flex;
}

.nav-meta .channels-button {
  margin-right: 1.5rem;
}

nav.desktop .cart {
  margin-right: 1.5em;
}

nav.mobile .cart {
  margin-right: 1em;
}

.cart-updated {
  color: #fa3b41;
}

a,
button {
  text-decoration: none;
  transition: color 150ms ease-out;
}

a:hover,
button:hover {
  color: #fff;
}

nav.invert a:hover,
nav.invert button:hover {
  color: #000;
}

/*a.router-link-active {
  color: #fff;
}*/

nav.mobile {
  display: flex;
  justify-content: flex-end;
  text-align: right;
  position: sticky;
  top: 0;
  z-index: 11;
  margin-bottom: 0.5rem;
}

nav.mobile .title {
  top: 0;
  left: 2rem;
  bottom: auto;
  right: auto;
}

nav.mobile ul {
  display: block;
}
/*nav.mobile ul li { display: inline; }*/
nav.mobile ul li:not(:last-child) {
  margin-right: 0;
}

nav.mobile .menu {
  position: absolute;
  bottom: 1px;
  left: 0;
  /*border-top: 1px dashed #fff;*/
  /*margin-top: 1.5rem;*/
  width: 100%;
  text-align: left;
  background: #000;
  transform: translateY(100%);
  padding: 1rem 2rem 1.6rem;
}

nav.invert.mobile .menu {
  background: #fff;
}

nav.mobile .follow-mobile {
  margin-top: 1em;
  font-size: 1.5em;
}

nav.mobile .follow-mobile a {
  margin-right: 0.5em;
}

.big {
  font-size: 1.5em;
  text-align: left;
}

.mobile .menu hr {
  margin: 0;
  position: relative;
  top: -1rem;
}

@media (min-width: 600px) {
  .big {
    text-align: right;
  }
}
</style>
